var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading"}},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t("utils.loading")))]),_c('font-awesome-icon',{attrs:{"icon":"spinner","size":"4x","spin":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }